import React, { Component, Fragment } from 'react';
import ComboBoxSearch from './ComboBoxSearch';
import { Grid, Typography, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import './MobileGameUmpire.css';

class MobileGameUmpire extends Component {
  state = {
    selectUmp: {},
    error: '',
    plate: this.props.plate
  };

  handleRemoveUmp = (umpireId, gameId, plate) => {
    this.props.removeUmp(umpireId, gameId, plate);
  };

  handleSelectUmp = (selectedOption, gameId, position) => {
    if (selectedOption) {
      const { value, label } = selectedOption;
      this.setState((prevState, props) => ({
        selectedUmp: {
          [position]: {
            name: label,
            umpireId: value,
            gameId,
            position
          }
        }
      }));
    } else {
      this.setState({ selectedUmp: { [position]: null } });
    }
  };

  handleAssignUmp = (gameId, position) => {
    if (this.state.selectedUmp[position] !== null) {
      const { umpireId } = this.state.selectedUmp[position];
      this.props.assignUmpToGame(umpireId, gameId, position);
    } else {
      this.setState({ error: 'Please select an umpire.' });
    }
  };

  handleUmpSignUp = (memberId, gameId, position) => {
    this.props.assignUmpToGame(memberId, gameId, position);
  };

  render() {
    const {
      umpires,
      umpiresList,
      userType,
      memberId,
      position,
      plate,
      selectedGame,
      division
    } = this.props;

    const umpireId = selectedGame[`${position}Id`];
    const isAdmin = userType === 'Admin';
    const isUmpire = umpires.hasOwnProperty(memberId);
    const isCancelled = selectedGame.cancelled;

    //Check if the Umpire is already scheduled to the Game
    let isOnGame = false;
    if (
      memberId === selectedGame.umpPlateId ||
      memberId === selectedGame.umpBase1Id ||
      memberId === selectedGame.umpBase2Id ||
      memberId === selectedGame.umpBase3Id
    ) isOnGame = true;

    //Get minimum Level required to Umpire the Game
    let minLevel = 1;
    if (division) {
      switch(position) {
        case 'umpPlate':
          minLevel = !division.umpPlateLevel ? 2 : division.umpPlateLevel;
          break;
        case 'umpBase1':
          minLevel = !division.umpBase1Level ? 1 : division.umpBase1Level;
          break;
        case 'umpBase2':
          minLevel = !division.umpBase2Level ? 1 : division.umpBase2Level;
          break;
        case 'umpBase3':
          minLevel = !division.umpBase3Level ? 1 : division.umpBase3Level;
          break;
        default:
          break;
      }
    }

    if (isAdmin || isUmpire) {
      let umpire = null;
      if (isUmpire) {
        umpire = umpires[memberId];
      }
      //Check that the Umpire is the valid level
      let isValidLevel = false; 
      if (umpire && umpire.umpireLevel >= minLevel) {
        isValidLevel = true;
      }
      //Check that the Umpire is allowed to sign up at this position
      let isPositionUmpire = false;
      if (position === 'umpPlate') {
        if (umpire && umpire.plateUmpire) {
          isPositionUmpire = true;
        }
      } else {
        if (umpire && umpire.baseUmpire) {
          isPositionUmpire = true;
        }
      }  
      return (
        <Grid container spacing={8} direction="row" alignItems="center">
          <Grid item xs={2} style={{paddingLeft: 12}}>
            <Typography variant="body1" align="left">{plate}({minLevel}):</Typography>
          </Grid>
          <Grid item xs={8}>
            {umpireId === null ? (
              <Fragment>
                {isAdmin ? (
                  <ComboBoxSearch
                    mobile="true"
                    placeholder="Select Umpire"
                    items={umpiresList}
                    onItemChange={selectedOption => this.handleSelectUmp(selectedOption, selectedGame.id, position)}
                  />
                ) : (
                  <Typography variant="body1" style={{fontStyle: 'italic'}}>No Umpire</Typography>
                )}
              </Fragment>
            ) : (
              <Fragment>
                <Typography variant="body1" >
                  {`${selectedGame[`${position}Name`]}
                  (${selectedGame[`${position}Level`]})`}
                </Typography>
                { isUmpire && umpires[umpireId] &&
                  <a href={`tel:${umpires[umpireId].phoneNumber}`}>{umpires[umpireId].phoneNumber}</a>
                }
              </Fragment>
            )}
          </Grid>
          <Grid item xs={2}>
            {(umpireId === null) &&
              <Fragment>
                {isAdmin && 
                  <IconButton
                    color="primary"
                    onClick={() => this.handleAssignUmp(selectedGame.id, position)}
                  >
                    <AddIcon />
                  </IconButton>
                }
                {(!isAdmin && isUmpire && !isOnGame && !isCancelled && isValidLevel && isPositionUmpire) &&
                  <IconButton
                    color="primary"
                    onClick={() => this.handleUmpSignUp(memberId, selectedGame.id, position)}
                  >
                    <AddIcon />
                  </IconButton>
                }
              </Fragment>
            }
            {(umpireId === memberId || (umpireId !== null && isAdmin)) &&
              <IconButton
                color="secondary"
                onClick={() => this.handleRemoveUmp(umpireId, selectedGame.id, position)}
              >
                <DeleteIcon />
              </IconButton>
            }
          </Grid>
        </Grid>
      );
    } else {
      return (
        <div className="mobile-game-umpire-container">
          {umpireId === null ? (
            <div className="mobile-game-umpire-innerContainer">
              <h3>{plate}({minLevel}):</h3>
              <ComboBoxSearch
                mobile="true"
                placeholder="Select umpire"
                items={umpiresList}
                onItemChange={selectedOption => this.handleSelectUmp(selectedOption, selectedGame.id, position)}
              />
              <button className="pt-button pt-intent-primary">Invite</button>
            </div>
          ) : (
            <div className="mobile-game-umpire-innerContainer">
              <h3>{plate}:</h3>
              <span className="ump-name">
                {`${selectedGame[`${position}Name`]} 
                (L${selectedGame[`${position}Level`]})`}
              </span>
            </div>
          )}
        </div>
      );
    } 
  }
}

export default MobileGameUmpire;



// WEBPACK FOOTER //
// ./src/components/MobileGameUmpire.js